import { LoadingOverlay } from "@sunrun/experience-ui-components";
import { AnalyticsIFrame } from "components/organisms/AnalyticsIFrame";
import { useAISalesAppJwt } from "providers/AISalesAppJwt";

const Analytics = () => {
  const { jwtResponse, error, isLoading } = useAISalesAppJwt();

  if (isLoading || (!jwtResponse && !error)) {
    return <LoadingOverlay message="Loading..." />;
  }

  if (error || !jwtResponse) {
    return (
      <div>
        <p>Error: {error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return <AnalyticsIFrame page="analytics" jwtResponse={jwtResponse} />;
};

export { Analytics };
